module.exports = __webpack_public_path__ + "img/7_montravail.4ba9fadb.jpg";